// extracted by mini-css-extract-plugin
module.exports = {"WordBreak":"Profile_WordBreak__3_YmI"};